import React from 'react';

import type { Department } from '@/entities/department';
// Import MemberData and getRoleLabel from the entity layer
import type { MemberData } from '@/entities/organization';
import { getRoleLabel } from '@/entities/organization';

import styles from './styles.module.css';

// 親コンポーネント (pages/organization-settings) から渡されるメンバー情報の型 (仮)
// export interface MemberData { // <- Remove definition
//   userId: string;
//   identifier: string; // 表示用
//   firstName?: string;
//   lastName?: string;
//   role: string; // 例: 'org:admin', 'org:member'
//   deptIds: string[]; // 現在所属している部署 ID の配列
//   membershipId?: string; // 必要であれば
// }

// Props の型定義
interface MemberDepartmentTableProps {
  members: MemberData[];
  departments: Department[];
  onAssignmentChange: (
    userId: string,
    deptId: string,
    isChecked: boolean
  ) => void; // 変更イベントハンドラ
  disabled?: boolean; // テーブル全体の無効化状態
}

export const MemberDepartmentTable: React.FC<MemberDepartmentTableProps> = ({
  members,
  departments,
  onAssignmentChange,
  disabled = false,
}) => {
  // Role の表示名を決定するヘルパー (必要なら shared/lib などへ)
  // const getRoleLabel = (role: string): string => { // <- Remove definition
  //   if (role === 'org:admin') return '管理者';
  //   if (role === 'org:member') return 'メンバー';
  //   return role; // その他のロールはそのまま表示
  // };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.memberDepartmentTable}>
        <thead>
          <tr>
            <th>メンバー</th>
            {departments.map((dept) => (
              <th key={dept.id}>{dept.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {members.map((member) => (
            <tr key={member.userId}>
              <td>
                <div>
                  {member.firstName || member.lastName
                    ? `${member.firstName} ${member.lastName}`.trim()
                    : member.identifier}
                </div>
                <span className={styles.memberRole}>
                  ({getRoleLabel(member.role)})
                </span>
              </td>
              {departments.map((dept) => (
                <td key={dept.id} className={styles.assignmentCell}>
                  <input
                    type="checkbox"
                    checked={(member.deptIds || []).includes(dept.id)}
                    // onChange で Props のハンドラを呼び出す
                    onChange={(e) =>
                      onAssignmentChange(
                        member.userId,
                        dept.id,
                        e.target.checked
                      )
                    }
                    disabled={disabled}
                    aria-label={`Assign ${member.identifier} to ${dept.name}`}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
